import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services';

@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.scss']
})
export class ThankyouComponent implements OnInit {
    public countries: Array<any> = [
        { text: 'Argentina', url: 'https://radiologia.bayer.com' },
        { text: 'Bolivia', url: 'https://radiologia.bayer.com' },
        { text: 'Brazil', url: 'https://radiologia.bayer.com.br' },
        { text: 'Canada', url: 'https://www.radiology.bayer.ca/en/rsna2020' },
        { text: 'Chile', url: 'https://radiologia.bayer.com' },
        { text: 'Colombia', url: 'https://radiologia.bayer.com' },
        { text: 'Costa Rica', url: 'https://radiologia.bayer.com' },
        { text: 'Ecuador', url: 'https://radiologia.bayer.com' },
        { text: 'El Salvador', url: 'https://radiologia.bayer.com' },
        { text: 'Guatemala', url: 'https://radiologia.bayer.com' },
        { text: 'Honduras', url: 'https://radiologia.bayer.com' },
        { text: 'Mexico', url: 'https://radiologia.bayer.com' },
        { text: 'Nicaragua', url: 'https://radiologia.bayer.com' },
        { text: 'Panamá', url: 'https://radiologia.bayer.com' },
        { text: 'Paraguay', url: 'https://radiologia.bayer.com' },
        { text: 'Peru', url: 'https://radiologia.bayer.com' },
        { text: 'República Dominicana', url: 'https://radiologia.bayer.com' },
        { text: 'Uruguay', url: 'https://radiologia.bayer.com' },
        { text: 'Venezuela', url: 'https://radiologia.bayer.com' },
        { text: 'Other Countries', url: 'https://www.rsna.radiology.bayer.com' },
        { text: 'Event Inquiries & Media Relations', url: '' }
    ];

    constructor(
        private modalSvc: ModalService
    ) { }

    ngOnInit(): void {
    }

    public countrySelect(val: string): void {
        const url = this.countries.find(el => el.text === val).url;
        if (url === '') {
            this.modalSvc.setActiveModalById('media');
        } else {
            window.open(url);
        }
    }
}
